module.exports = __webpack_public_path__ + "/assets/img/icon_ahref588d5d12.svg";